<template>
  <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Profile' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <potential-customer-profile-details-view/>
      </div>
    </vs-tab>

  </vs-tabs>
</template>

<script>
  import PotentialCustomerProfileDetailsView from './PotentialCustomerProfileDetailsView.vue'

  export default {
    components: {
      PotentialCustomerProfileDetailsView
    },
    data () {
      return {
        active_step: this.$route.query.step ? this.$route.query.step : '0'
      }
    },
    mounted() {
        // this.active_step = this.$route.query.step
    },
    computed: {
      isSmallerScreen () {
        return this.$store.state.windowWidth < 768
      }
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
